document.addEventListener('DOMContentLoaded', function () {
  function moveExistingKiwiSizeGuide() {
    var sizeGuide = document.querySelector('.ks-chart-container');
    var variantPicker = document.querySelector('variant-picker');

    if (!sizeGuide || !variantPicker) return;

    var sizeFieldset = null;

    variantPicker.querySelectorAll('.variant-picker__option').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');

      if (!legend) return;

      var label = legend.textContent.trim().toLowerCase();

      if (
        label.includes('size') ||
        label.includes('størrelse') ||
        label.includes('storrelse') ||
        label.includes('str')
      ) {
        sizeFieldset = fieldset;
      }
    });

    if (sizeFieldset) {
      variantPicker.insertBefore(sizeGuide, sizeFieldset);
    }
  }

  moveExistingKiwiSizeGuide();
  setTimeout(moveExistingKiwiSizeGuide, 1000);
  setTimeout(moveExistingKiwiSizeGuide, 2500);
});